export default __webpack_public_path__ + "static/media/sea-example.47d508ea.png";